import type {
  AnalyticsCampaignType,
  IAnalyticsManager,
} from "@shared/common/types/sdk";
import { logError } from "../util/common";

export const setConversionId = (conversionId: string) => {
  if (typeof window === "undefined") {
    return;
  }

  // codenbutter의 conversionId를 sessionStorage에 저장
  window.sessionStorage.setItem("cbConversionId", conversionId);
};

export const getConversionId = () => {
  if (typeof window === "undefined") {
    return null;
  }

  // codenbutter의 conversionId를 sessionStorage에서 가져옴
  return window.sessionStorage.getItem("cbConversionId");
};

export const initConversionId = () => {
  const url = new URL(window.location.href);
  const conversionId = url.searchParams.get("cbcid");
  if (conversionId) {
    setConversionId(conversionId);
  }
};

export const trySendImpressionByConversionId = ({
  analyticsManager,
  siteId,
}: {
  siteId: string;
  analyticsManager: IAnalyticsManager;
}) => {
  const url = new URL(window.location.href);
  const conversionId = url.searchParams.get("cbcid");
  const conversionCampaignType = url.searchParams.get("cbct");
  if (conversionId) {
    analyticsManager
      .sendAnalyticsEvent({
        type: "IMPRESSION",
        siteId,
        campaignId: conversionId,
        campaignType: (conversionCampaignType ||
          "CONVERSION") as AnalyticsCampaignType, // TODO: AnalyticsCampaignType 타입 정의 필요
      })
      .catch(logError);
  }
};
